import SectionHeading from '@/components/base/SectionHeading';
import { showToast } from '@/components/base/Toast';
import { setList } from '@/mocks/home';

export default function PhotoSetGrid() {
  return (
    <section id="sets" className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-[1200px]">
          <SectionHeading
            index="03"
            eyebrow="Private Set"
            title="私拍套图"
            desc="按拍摄场景与主题归档的私拍套图，每套标注张数，方便按主题快速挑选收藏。"
            actionLabel="按主题筛选"
            onAction={() => showToast('静态展示：主题筛选为演示交互')}
          />

          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-6">
            {setList.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => showToast('静态展示：套图详情暂未开放')}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 text-left transition-colors duration-200 hover:border-primary-300"
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} - 善良的女秘书 私拍套图封面`}
                    title={`${item.title} - 善良的女秘书角色扮演 私拍套图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute right-2 top-2 rounded bg-foreground-950/75 px-2 py-0.5 text-[11px] text-background-100">
                    {item.photos}P
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-3">
                  <h3 className="font-heading text-xs font-semibold leading-snug text-foreground-950 md:text-sm">
                    {item.title}
                  </h3>
                  <span className="mt-2 inline-flex w-fit items-center rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                    {item.tag}
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}